  
  (function () {
  const animationClassNames = [
    'to-top',
    'cmbty-animate'
  ];

  const selector = animationClassNames.map(c => `.${c}`).join(',');
  const elements = document.querySelectorAll(selector);

  if (!elements.length) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const el = entry.target;
      const isIn = entry.isIntersecting;

      // ===== to-top + data-active：进入加，离开移除 =====
      if (
        el.classList.contains('to-top') &&
        el.dataset.active !== undefined
      ) {
        requestAnimationFrame(() => {
          el.classList.toggle('appear', isIn);
        });
        return;
      }

      // ===== shake-once =====
      if (el.classList.contains('shake-once')) {
        if (isIn) {
          if (!el.dataset.shakeTimer) {
            el.classList.add('appear');
            const timer = setInterval(() => {
              el.classList.remove('appear');
              requestAnimationFrame(() => {
                el.classList.add('appear');
              });
            }, 3000);
            el.dataset.shakeTimer = timer;
          }
        } else {
          if (el.dataset.shakeTimer) {
            clearInterval(el.dataset.shakeTimer);
            delete el.dataset.shakeTimer;
            el.classList.remove('appear');
          }
        }
        return;
      }

      // ===== 普通动画（只触发一次）=====
      if (isIn) {
        requestAnimationFrame(() => {
          el.classList.add('appear');
        });
        observer.unobserve(el);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px 50px 0px',
    threshold: 0.3
  });

  // 分批 observe
  let index = 0;
  const batchSize = 20;

  const observeNext = () => {
    const end = Math.min(index + batchSize, elements.length);
    for (; index < end; index++) {
      observer.observe(elements[index]);
    }
    if (index < elements.length) {
      (window.requestIdleCallback || setTimeout)(observeNext, 100);
    }
  };

  observeNext();
})();



class CustomSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
    this.resizeHandler = this.handleResize.bind(this);
  }

  connectedCallback() {
    // 初始化
    this.initSwiper();
    window.addEventListener('resize', this.resizeHandler);
  }

  disconnectedCallback() {
    this.destroySwiper();
    window.removeEventListener('resize', this.resizeHandler);
  }

  handleResize() {
    this.initSwiper();
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  /**
   * 检查是否应该禁用 Swiper
   * @returns {boolean}
   */
  shouldDisable() {
    const disableOn = this.getAttribute('disable-on'); // 'mobile' | 'desktop'
    if (!disableOn) return false;

    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    if (disableOn === 'mobile' && isMobile) return true;
    if (disableOn === 'desktop' && !isMobile) return true;

    return false;
  }

  getConfig() {
    // 提取布尔值的辅助函数
    const getBool = (attr, defaultVal = false) => {
      const val = this.getAttribute(attr);
      return val === null ? defaultVal : val !== 'false';
    };

    // 提取数字的辅助函数
    const getNum = (attr, defaultVal) => {
      const val = parseFloat(this.getAttribute(attr));
      return isNaN(val) ? defaultVal : val;
    };

    const navigationEnabled = getBool('navigation', false);
    const paginationEnabled = getBool('pagination', false);

    // 获取断点配置
    let breakpoints = {};
    try {
      breakpoints = JSON.parse(this.getAttribute('breakpoints') || '{}');
    } catch (e) {
      console.warn('CustomSwiper: Invalid breakpoints JSON', e);
    }

    return {
      slidesPerView: getNum('slides-per-view', 1.3),
      spaceBetween: getNum('space-between', 10),
      loop: getBool('loop', true),
      centeredSlides: getBool('centered-slides', true),
      breakpoints: breakpoints,
      // 模块配置
      navigation: navigationEnabled ? {
        prevEl: this.querySelector('.swiper-button-prev') || this.querySelector('.swiper-prev'),
        nextEl: this.querySelector('.swiper-button-next') || this.querySelector('.swiper-next'),
      } : false,
      pagination: paginationEnabled ? {
        el: this.querySelector('.swiper-pagination'),
        clickable: true
      } : false,
      autoplay: getBool('autoplay', false) ? { delay: 3000, disableOnInteraction: false } : false,
    };
  }

  initSwiper() {
    const swiperContainer = this.querySelector('.swiper') || this.querySelector('.swiper-container');
    if (!swiperContainer) return;

    // 1. 检查是否需要禁用
    if (this.shouldDisable()) {
      // 如果当前已经存在实例但需要禁用，则销毁它
      if (this.swiper) this.destroySwiper();
      return; // 退出，不初始化
    }

    // 2. 如果已经初始化且不需要禁用，则跳过（避免重复初始化）
    if (this.swiper) return;

    // 3. 获取配置并初始化
    const config = this.getConfig();

    // 确保 Swiper 库已加载
    if (typeof Swiper === 'undefined') {
      console.error('Swiper library is not loaded.');
      return;
    }

    this.swiper = new Swiper(swiperContainer, config);


    // 触发一个自定义事件，方便外部知道 Swiper 初始化完成了
    this.dispatchEvent(new CustomEvent('swiper-init', { detail: { instance: this.swiper } }));
  }
}

// 定义组件
if (!customElements.get('custom-swiper-new')) {
  window.customElements.define('custom-swiper', CustomSwiper);
}


class VideoCarousel extends HTMLElement {
  constructor() {
    super();
    this.isPlaying = true;
    this.isEnded = false;
    this.swiperInstance = null;
    this._lastIsMobile = null;
    this._onResize = null;
    this.observer = null; 
  }


  isMobile() {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  getVideoByIndex(index, mobile = this.isMobile()) {
    const slide = this.slides?.[index];
    if (!slide) return null;

    return mobile
      ? slide.querySelector('.video_carsoule-mb video')
      : slide.querySelector('.video_carsoule-pc video');
  }

  getActiveVideo() {
    if (!this.swiperInstance) return null;
    return this.getVideoByIndex(this.swiperInstance.activeIndex);
  }

  connectedCallback() {
    this.swiperEl = this.querySelector('.video_carsoule-container');
    if (!this.swiperEl) return;

    this.slides = this.querySelectorAll('.swiper-slide');
    this.dots = this.querySelectorAll('.dotnav-item');
    this.btnWrapper = this.querySelector('.play-pause-button-wrapper');
    this.btn = this.querySelector('.play-pause-button');

    this._lastIsMobile = this.isMobile();

    this.waitForVideos().then(() => {
      this.initSwiper();
      this.bindEvents();
      this.initObserver(); 
    });

    this._onResize = this.handleResize.bind(this);
    window.addEventListener('resize', this._onResize);
  }

  disconnectedCallback() {
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }

    window.removeEventListener('resize', this._onResize);
  }


  initObserver() {
    // 设置阈值为 0.8，表示元素至少 80% 可见时才触发
    const options = {
      root: null, // 默认为视口
      threshold: 0.8
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 进入视口
          if (!this.isEnded) { // 如果整个播放流程没结束，则继续播放
            this.isPlaying = true;
            this.playCurrentVideo();
            this.updateUIState();
          }
        } else {
          // 离开视口
          this.isPlaying = false;
          this.pauseCurrentVideo();
          this.updateUIState();
        }
      });
    }, options);

    this.observer.observe(this);
  }


  waitForVideos() {
    return Promise.all(
      [...this.slides].map(slide => {
        const video = this.isMobile()
          ? slide.querySelector('.video_carsoule-mb video')
          : slide.querySelector('.video_carsoule-pc video');

        if (!video) return Promise.resolve();
        if (video.readyState > 0) return Promise.resolve();

        return new Promise(resolve => {
          video.addEventListener('loadedmetadata', resolve, { once: true });
        });
      })
    );
  }


  initSwiper() {
    if (this.swiperInstance) return;

    this.swiperInstance = new Swiper(this.swiperEl, {
      slidesPerView: 1,
      spaceBetween: 30,
      speed: 500,
      allowTouchMove:  this.isMobile() ? true : false,
      on: {
        init: () => {
          this.updateUIState();
          this.setActiveDot(0);
          requestAnimationFrame(() => {
            this.playCurrentVideo();
          });
        },
        slideChange: () => this.handleSlideChange()
      }
    });
  }


  handleResize() {
    if (!this.swiperInstance) return;

    const nowIsMobile = this.isMobile();
    if (nowIsMobile === this._lastIsMobile) return;

    const index = this.swiperInstance.activeIndex;
    this.syncVideoState(index, this._lastIsMobile, nowIsMobile);

    this._lastIsMobile = nowIsMobile;
  }

  syncVideoState(index, fromMobile, toMobile) {
    const fromVideo = this.getVideoByIndex(index, fromMobile);
    const toVideo = this.getVideoByIndex(index, toMobile);

    if (!fromVideo || !toVideo) return;

    const currentTime = fromVideo.currentTime || 0;
    const wasPlaying = !fromVideo.paused && !fromVideo.ended;

    fromVideo.pause();

    if (toVideo.readyState === 0) {
      toVideo.load();
    }

    const apply = () => {
      toVideo.currentTime = Math.min(
        currentTime,
        toVideo.duration || currentTime
      );

      if (wasPlaying && this.isPlaying) {
        toVideo.play().catch(() => {});
      }
    };

    if (toVideo.readyState >= 1) {
      apply();
    } else {
      toVideo.addEventListener('loadedmetadata', apply, { once: true });
    }
  }


  handleSlideChange() {
    this.slides.forEach((_, index) => {
      const pc = this.getVideoByIndex(index, false);
      const mb = this.getVideoByIndex(index, true);

      [pc, mb].forEach(video => {
        if (!video) return;
        video.pause();
        video.currentTime = 0;
      });

      this.updateDotProgress(index, 0);
      this.dots[index]?.classList.remove('active');
    });

    const currentIndex = this.swiperInstance.activeIndex;
    this.setActiveDot(currentIndex);

    if (this.isPlaying) {
      this.playCurrentVideo();
    }
  }


  playCurrentVideo() {
    const video = this.getActiveVideo();
    if (!video) return;

    video.play().catch(() => {
      this.isPlaying = false;
      this.updateUIState();
    });
  }

  pauseCurrentVideo() {
    const video = this.getActiveVideo();
    video?.pause();
  }


  bindEvents() {
    this.slides.forEach((_, index) => {
      const pc = this.getVideoByIndex(index, false);
      const mb = this.getVideoByIndex(index, true);

      [pc, mb].forEach(video => {
        if (!video) return;

        video.addEventListener('timeupdate', () => {
          if (index !== this.swiperInstance.activeIndex) return;

          const percent = video.duration
            ? (video.currentTime / video.duration) * 100
            : 0;

          this.updateDotProgress(index, percent);
        });

        video.addEventListener('ended', () => {
          if (index < this.slides.length - 1) {
            this.swiperInstance.slideNext();
          } else {
            this.isPlaying = false;
            this.isEnded = true;
            this.updateUIState();
          }
        });
      });
    });

    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.isPlaying = false;
        this.isEnded = false;
        this.updateUIState();
        this.swiperInstance.slideTo(index);
      });
    });

    this.btn?.addEventListener('click', () => {
      if (this.isEnded) {
        this.isEnded = false;
        this.isPlaying = true;
        this.updateUIState();
        this.swiperInstance.slideTo(0);
        return;
      }

      this.isPlaying ? this.pauseCurrentVideo() : this.playCurrentVideo();
      this.isPlaying = !this.isPlaying;
      this.updateUIState();
    });
  }


  setActiveDot(index) {
    this.dots[index]?.classList.add('active');
  }

  updateDotProgress(index, percent) {
    this.dots[index]?.style.setProperty('--prog', percent + '%');
  }

  updateUIState() {
    if (!this.btnWrapper) return;

    this.btnWrapper.classList.remove('playing', 'paused', 'ended');
    this.btnWrapper.classList.add(
      this.isEnded ? 'ended' : this.isPlaying ? 'playing' : 'paused'
    );
  }
}

customElements.define('video-carousel', VideoCarousel);


class ProductColorPicker extends HTMLElement {
  constructor() {
    super();
    // 绑定 this 指向，防止监听丢失上下文
    this.handleInput = this.handleInput.bind(this);
  }

  connectedCallback() {
    // 获取组件内所有的 radio
    this.inputs = this.querySelectorAll('input[type="radio"]');
    // 获取显示文字的元素 (根据你提供的 HTML id)
    this.labelEl = this.querySelector('#colorLabel') || this.querySelector('.label-text');

    // 绑定监听
    this.inputs.forEach(input => {
      input.addEventListener('change', this.handleInput);
    });
  }

  disconnectedCallback() {
    // 组件销毁时移除监听
    this.inputs.forEach(input => {
      input.removeEventListener('change', this.handleInput);
    });
  }

  handleInput(e) {
    const newColor = e.target.value;

    this.dispatchEvent(new CustomEvent('color-change', {
      detail: { value: newColor },
      bubbles: true,
      composed: true
    }));

    // --- B. 执行文字切换动画 ---
    if (this.labelEl) {
      // 1. 变淡
      this.labelEl.style.transition = 'opacity 0.2s ease';
      this.labelEl.style.opacity = '0.5';

      // 2. 100ms 后切换文字并恢复
      setTimeout(() => {
        this.labelEl.innerText = newColor;
        this.labelEl.style.opacity = '1';
      }, 100);
    }
  }
}


class ProductImageSwitcher extends HTMLElement {
  constructor() {
    super();
    this.handleGlobalColorChange = this.handleGlobalColorChange.bind(this);
  }

  connectedCallback() {
    // --- A. 监听全局事件 ---
    window.addEventListener('color-change', this.handleGlobalColorChange);

    // --- B. 初始化检查 ---
    // 如果组件上有 current-color 属性，或者根据第一个显示的图片初始化
    const initialColor = this.getAttribute('current-color') || 'Starlight'; // 默认值
    this.updateVisibility(initialColor);
  }

  disconnectedCallback() {
    window.removeEventListener('color-change', this.handleGlobalColorChange);
  }

  handleGlobalColorChange(e) {
    const color = e.detail.value;
    if (color) {
      this.updateVisibility(color);
    }
  }

  updateVisibility(activeColor) {
    // 找到内部所有带有 data-color 的元素
    const targets = this.querySelectorAll('[data-color]');

    targets.forEach(el => {
      const elColor = el.getAttribute('data-color');

      if (elColor === activeColor) {
        // 匹配：显示
        el.style.display = 'block'; 

        el.classList.add('fade-in');
      } else {
        // 不匹配：隐藏
        el.style.display = 'none';
        el.classList.remove('fade-in');
      }
    });
  }
}

// 3. 注册组件 
if (!customElements.get('product-color-picker')) {
  customElements.define('product-color-picker', ProductColorPicker);
}

if (!customElements.get('product-image-switcher')) {
  customElements.define('product-image-switcher', ProductImageSwitcher);
}


class useSwitch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();

    requestAnimationFrame(() => {
      const defaultTab = this.querySelector('.tabnav-item.active');
      if (defaultTab) this.moveIndicatorTo(defaultTab);
    });
  }
  init() {
    this.tabIndicator = this.querySelector('.tabnav-indicator');
    this.hsTabs = this.querySelector('.tabnav');
    this.tabs = this.querySelectorAll(".tabnav-item");
    this.lists = this.querySelectorAll(".main-control_pic");
    this.texts = this.querySelectorAll(".ml-text-item");
    this.videoWrapper = this.querySelector(".hs__item-video-wrapper");
    this.videoEl = this.videoWrapper?.querySelector("video");
    this.pd = this.isMobile() ? 3 : 4;

    
      this.scrollContainer = this.querySelector(".tabnav-mask-scroll");
  this.prevBtn = this.querySelector(".tabnav-paddle-left");
  this.nextBtn = this.querySelector(".tabnav-paddle-right");

    this.bindPaddles();
  this.updatePaddles();

  this.scrollContainer?.addEventListener("scroll", () => {
    this.updatePaddles();
  });

    if (this.videoEl) {
      const sources = this.videoEl.querySelectorAll("source");
      this.pcVideoSrc = [...sources].find(s => s.media.includes("min-width"))?.src || "";
      this.mobVideoSrc = [...sources].find(s => s.media.includes("max-width"))?.src || "";
    }

    this.tabs.forEach((tab, i) => {
      tab.addEventListener("click", () => {
        this.querySelector(".tabnav-item.active")?.classList.remove("active");
        tab.classList.add("active");
        this.moveIndicatorTo(tab);
         this.scrollTabToCenter(tab);
        this.switchItem(i)
      })
    })

  }
    isMobile() {
    return window.matchMedia('(max-width: 991px)').matches;
  }
bindPaddles() {
  this.prevBtn?.addEventListener("click", () => {
    const current = this.getActiveIndex();
    this.switchToTabByIndex(current - 1);
  });

  this.nextBtn?.addEventListener("click", () => {
    const current = this.getActiveIndex();
    this.switchToTabByIndex(current + 1);
  });
}


updatePaddles() {
  if (!this.scrollContainer) return;

  const { scrollLeft, scrollWidth, clientWidth } = this.scrollContainer;

  const canScrollLeft = scrollLeft > 1;
  const canScrollRight = scrollLeft + clientWidth < scrollWidth - 1;

  this.togglePaddle(this.prevBtn, canScrollLeft);
  this.togglePaddle(this.nextBtn, canScrollRight);
}

togglePaddle(btn, show) {
  if (!btn) return;

  btn.classList.toggle("tabnav-paddle-hidden", !show);
  btn.disabled = !show;
  btn.tabIndex = show ? 0 : -1;
}

getActiveIndex() {
  return [...this.tabs].findIndex(tab =>
    tab.classList.contains("active")
  );
}

switchToTabByIndex(index) {
  if (index < 0 || index >= this.tabs.length) return;

  const targetTab = this.tabs[index];

  this.querySelector(".tabnav-item.active")?.classList.remove("active");
  targetTab.classList.add("active");

  this.moveIndicatorTo(targetTab);
  this.scrollTabToCenter(targetTab);
  this.switchItem(index);
}

moveIndicatorTo(tabEl) {
  if (!this.tabIndicator) return;

  const scrollContainer = this.querySelector(".tabnav-mask-scroll");

  const containerRect = scrollContainer.getBoundingClientRect();
  const tabRect = tabEl.getBoundingClientRect();

  const tabCenter =
    tabRect.left - containerRect.left +
    scrollContainer.scrollLeft +
    tabRect.width / 2;

  let targetScrollLeft = tabCenter - containerRect.width / 2;

  const maxScroll =
    scrollContainer.scrollWidth - containerRect.width;

  targetScrollLeft = Math.max(
    0,
    Math.min(targetScrollLeft, maxScroll)
  );

  const left = tabEl.offsetLeft - targetScrollLeft;
  const width = tabEl.offsetWidth;

  this.tabIndicator.style.transform = `translateX(${left + this.pd}px)`;
  this.tabIndicator.style.width = `${width}px`;
}

  switchItem(i) {

    this.querySelector(".main-control_pic.active")?.classList.remove("active");
    this.lists[i].classList.add("active");
    this.querySelector(".ml-text-item.active")?.classList.remove("active");
    this.texts[i].classList.add("active");


    if (!this.videoEl) return;

    if (this.lists[i].classList.contains("hs__item-video-wrapper")) {
      
      const isMobile = window.matchMedia("(max-width: 991px)").matches;
      const newSrc = isMobile ? this.mobVideoSrc : this.pcVideoSrc;

      if (this.videoEl.src !== newSrc) {
        this.videoEl.src = newSrc;
        this.videoEl.load();
      }

      this.videoEl.currentTime = 0;
      this.videoEl.play().catch(() => { });
    } else {
      this.videoEl.pause();
      this.videoEl.currentTime = 0;
    }
  }

scrollTabToCenter(tabEl) {
  const isMobile = window.matchMedia("(max-width: 991px)").matches;
  if (!isMobile) return;

  const scrollContainer = this.querySelector(".tabnav-mask-scroll");
  if (!scrollContainer) return;

  const containerRect = scrollContainer.getBoundingClientRect();
  const tabRect = tabEl.getBoundingClientRect();

  const tabCenter =
    tabRect.left - containerRect.left +
    scrollContainer.scrollLeft +
    tabRect.width / 2;

  let targetScrollLeft = tabCenter - containerRect.width / 2;

  const maxScroll =
    scrollContainer.scrollWidth - containerRect.width;

  targetScrollLeft = Math.max(
    0,
    Math.min(targetScrollLeft, maxScroll)
  );

  scrollContainer.scrollTo({

    left: targetScrollLeft,
    behavior: "smooth",
  });
}



}

window.customElements.define("use-switch", useSwitch);





class ScrollingSegment extends HTMLElement {
  constructor() {
    super();
    this.scrollTrigger = null;
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      this.initScrollTrigger();
    });
  }

  disconnectedCallback() {
    if (this.scrollTrigger) {
      this.scrollTrigger.kill();
      this.scrollTrigger = null;
    }
  }

initScrollTrigger() {
  const section = this.querySelector('.scroll-segment-section');
  const bgsection = this.querySelector('.custom-mask__bg');
  if (!section) return;
  if(bgsection){
    gsap.set(bgsection, { yPercent: 80 });
  }

  const boxes = gsap.utils.toArray(
    section.querySelectorAll('.scroll-segment-box')
  );
  if (!boxes.length) return;

  let lastIndex = -1; 

  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: 'top top',
      end: `+=${boxes.length * 60}%`,
      scrub: true,
      onUpdate: (self) => {
        const index = Math.min(
          boxes.length - 1,
          Math.floor(self.progress * boxes.length)
        );

    
        if (index === lastIndex) return;
        lastIndex = index;

        boxes.forEach((box, i) => {
          const left = box.querySelector('.scroll-segment-content');
          const isActive = i === index;

          gsap.to(box, {
            opacity: isActive ? 1 : 0,
            zIndex: isActive ? 2 : 1, 
            duration: 0.3,
            ease: 'power1.out'
          });

          left?.classList.toggle('active', isActive);
        });
      }
    }
  });

  if (bgsection) {
    tl.to(bgsection, { yPercent: 0, ease: 'none' }, 1);
  }

  this.scrollTrigger = tl.scrollTrigger;
}

}

customElements.define('scroll-segment', ScrollingSegment);



class RemoteMic extends HTMLElement {
  constructor() {
    super();
    this.tl = null;
     this.isMobile = window.innerWidth < 992;
  }

  connectedCallback() {
  if (this.isMobile) return;
    requestAnimationFrame(() => {
      this.init();
    });
  }

  disconnectedCallback() {
    if (this.tl) {
      this.tl.scrollTrigger?.kill();
      this.tl.kill();
      this.tl = null;
    }
  }

  init() {
    const section = this.querySelector('.remote-mic-section');
    if (!section) return;

    const picImgs = this.querySelector('.remote-mic-pic video');
    const text = this.querySelector('.remote-mic-txt');
    const bg = this.querySelector('.custom-mask__bg');
    const videoBox = this.querySelector('.remote-mic-bottom');
    const tleBox =  this.querySelector('.remote-mic-h2');

    if (!picImgs) return;

  if(bg){
    gsap.set(bg, { yPercent: 80 });
  }

    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: '+=200%', 
        scrub: true,
        onUpdate: (self) => {
          if (text) {
            text.classList.toggle('active', self.progress > 0.4); 
          }
        }
      }
    });

   
    this.tl.fromTo(
      videoBox,
      { width: '56%', height: '56%',top: '38%' },
      {
        width: '100%',
        height: '100%',
        top: '0%',
        ease: 'none',
        duration: 1 
      }
    );

      this.tl.fromTo(
      tleBox,
      {   yPercent: 0, },
      {
        yPercent: -100,
        ease: 'none',
        duration: 1 
      },0
    );


    if (bg) {
      this.tl.to(
        bg,
        {
          yPercent: 0,
          ease: 'none',
          duration: 1 
        },
        '+=0.5' 
      );
    }
  }
}

customElements.define('remote-mic', RemoteMic);



class MainControl extends HTMLElement {
  constructor() {
    super();
    this.animation = null;
      this.isMobile = window.innerWidth < 992;
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      this.init();
    });
  }

  disconnectedCallback() {
    if (this.animation) {
      this.animation.scrollTrigger?.kill();
      this.animation.kill();
      this.animation = null;
    }
  }

  init() {
     if (this.isMobile) return;
    const section = this.querySelector('.main-control_section');
    if (!section) return;

    const pics = this.querySelectorAll('.main-control_pic img, .main-control_pic-pst img');
    const text = this.querySelector('.main-control_btx');
    

    const switchBox = this.querySelector('.use-switch-box');

    this.textHeight = this.querySelector('.main-control_top');
    this.section = this.querySelector('.main-control_section');

    if (this.textHeight && this.section) {
      const height = this.textHeight.offsetHeight;
      this.section.style.setProperty('--p-height', `${height}px`);
    }

    if (!pics.length) return;


    this.animation = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: '+=130%',
        scrub: true,
        onUpdate: (self) => {
          if (text) {
            text.classList.toggle('active', self.progress > 0.6);
          }
        }
      }
    });


    this.animation.fromTo(
      pics, 
      { scale: 1.5 }, 
      { scale: 1, ease: 'none' }, 
      0 
    );


    if (switchBox &&  this.isMobile) {
      this.animation.fromTo(
        switchBox,
        { y: 0 },            
        { y: '-14vh', ease: 'none' }, 
        0                   
      );
    }
  }
}

customElements.define('main-control', MainControl);



class HearEveryDetail extends HTMLElement {
  constructor() {
    super();
    this.tl = null;
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      this.init();
    });
  }

  disconnectedCallback() {
    if (this.tl) {
      this.tl.scrollTrigger?.kill();
      this.tl.kill();
      this.tl = null;
    }
  }

  init() {
    const section = this.querySelector('.hear-every-detail-section');
    const list = this.querySelector('.hear-every-detail_list');
    if (!section || !list) return;

    
    const sections = gsap.utils.toArray(list.children);
    if (sections.length < 2) return;

    
    this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: '+=' + sections.length * 40 + '%',
        scrub: 1.3
      }
    });

    
    sections.forEach((current, i) => {
      if (i === 0) return;

      const prev = sections[i - 1];
      const next = current;

      
      this.tl.to({}, { duration: 0.7 });

      
      this.tl
        .to(prev, {
          opacity: 0,
          duration: 1,
          ease: 'none'
        })
        .fromTo(
          next,
          {
            visibility: 'hidden',
            yPercent: 100
          },
          {
            visibility: 'visible',
            yPercent: 0,
            duration: 1,
            ease: 'none'
          },
          '<'
        );
    });
  }
}

customElements.define('hear-every-detail', HearEveryDetail);






class PersonalizedApp extends HTMLElement {
  constructor() {
    super();
    this.tween = null;
    this.isMobile = window.innerWidth < 991;
  }

  connectedCallback() {
    if (!this.isMobile) {
         requestAnimationFrame(() => {
      this.init();
    });
    } 

  }

  disconnectedCallback() {
    if (this.tween) {
      this.tween.scrollTrigger?.kill();
      this.tween.kill();
      this.tween = null;
    }
  }

  init() {
    const stick = this.querySelector('.personalized-app-section');
    const inner = this.querySelector('.personalized-app-wrapper');
    const moveTarget = this.querySelector('.personalized-app-inner');

    if (!stick || !inner || !moveTarget) return;

    const getTargetX = () => {
      const rect = inner.getBoundingClientRect();
      const vw = window.innerWidth;

      let hidden = 0;

      if (rect.right > vw) {
        hidden = rect.right - vw;
      }
      
      else if (rect.left < 0) {
        hidden = -rect.left;
      }


      const items = inner.children;
      let spacing = 0;

      if (items.length > 1) {
        const style = getComputedStyle(inner);
        const gap = parseFloat(style.columnGap || style.gap || 0);
        spacing += gap * (items.length - 1);

        for (let i = 0; i < items.length - 1; i++) {
          const itemStyle = getComputedStyle(items[i]);
          spacing += parseFloat(itemStyle.marginRight || 0);
        }
      }

      // 最终目标 x（向左）
      return -(hidden + spacing);
    };

    this.tween = gsap.to(moveTarget, {
      x: () => getTargetX(),
      ease: 'none',
      scrollTrigger: {
        trigger: this,
        start: 'top top',
        // pin: true,
        end: () => '+=' + Math.abs(getTargetX()),
        scrub: 1.5,
        markers: false,
        invalidateOnRefresh: true
      }
    });
  }
}

customElements.define('personalized-app', PersonalizedApp);


class NativeVideo extends HTMLElement {
  constructor() {
    super();
    this.hasLoaded = false;
    this.observer = null;
    this.videoEl = null;
    this.replayBtn = null; 
  }

  connectedCallback() {
    this.style.position = "relative";
    this.style.display = "block"; 

    if (!this.hasLoaded) {
      this._replaceContent();
    }

    this._initObserver();
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  play() {
    if (!this.videoEl) return;

    if (this.replayBtn) {
      this.replayBtn.style.display = "none";
    }

    this.videoEl.muted = true;
    this.videoEl.playsInline = true;

    const p = this.videoEl.play();
    if (p && p.catch) p.catch(() => {});
  }

  pause() {
    if (!this.videoEl) return;
    this.videoEl.pause();
  }

  _replaceContent() {
    const isMobile = window.matchMedia("(max-width: 768px)").matches;

    const desktopTpl = this.querySelector('template[data-device="desktop"]');
    const mobileTpl = this.querySelector('template[data-device="mobile"]');

    let template = null;
    if (isMobile && mobileTpl) {
      template = mobileTpl;
    } else {
      template = desktopTpl;
    }

    if (!template) return;

    const node = template.content.firstElementChild.cloneNode(true);

    this.innerHTML = "";
    this.appendChild(node);

    this.videoEl = node.tagName === "VIDEO" ? node : node.querySelector("video");

    if (!this.videoEl) return;

    this.videoEl.preload = "metadata";

    this.videoEl.addEventListener("play", () => {
      this.dispatchEvent(new CustomEvent("video:played", { bubbles: true }));
    });

    this.videoEl.addEventListener("pause", () => {
      this.dispatchEvent(new CustomEvent("video:paused", { bubbles: true }));
    });


    

    if (this.hasAttribute("show-replay")) {
      this._initReplayFeature();
    }



    this.hasLoaded = true;

    this.dispatchEvent(
      new CustomEvent("native-video:ready", { bubbles: true })
    );
  }

  _initReplayFeature() {
    const btn = document.createElement("button");
    btn.innerHTML = `
    <svg fill="none"><g><path d="M13.742893994715228,6.1418085L11.941048994715228,4.3399639C10.948190994715228,3.3471055,10.948190994715228,1.7373643,11.941048994715228,0.74450612C12.933906994715228,-0.24835211,14.54364799471523,-0.24835205,15.536506994715229,0.74450636L21.28923899471523,6.4972386C21.83014399471523,7.0381427,22.076364994715227,7.7621384,22.02790499471523,8.4697313C22.076364994715227,9.1773148,21.83014399471523,9.90131,21.28923899471523,10.442215L15.536506994715229,16.194946C14.54364799471523,17.187805,12.933906994715228,17.187805,11.941048994715228,16.194946C10.948190994715228,15.202089,10.948190994715228,13.592348,11.941048994715228,12.599489L13.330390994715229,11.210148Q10.342820994715229,10.957953,7.970537794715229,12.847079Q5.499158094715229,14.81512,5.143243494715229,17.954264Q4.7873297947152285,21.093407,6.755369794715229,23.564787Q8.723411294715229,26.036167,11.86255399471523,26.392082Q15.001696994715228,26.747995,17.47307799471523,24.779957Q19.944456994715228,22.811914,20.30036999471523,19.672771C20.458553994715228,18.277597,21.71780299471523,17.274818,23.11297699471523,17.433002C24.50815499471523,17.591187,25.51092999471523,18.850433,25.352745994715228,20.245607Q24.759555994715228,25.477512,20.64058899471523,28.75758Q16.52162199471523,32.037647,11.289717994715229,31.444458Q6.057812394715229,30.851267,2.7777441947152286,26.732298Q-0.5023225052847713,22.613333,0.09086756971522868,17.381428Q0.6840585947152287,12.149521,4.803024894715229,8.8694534Q8.759522094715228,5.7187667,13.742893994715228,6.1418085Z" fill-rule="evenodd" fill="#FFFFFF" fill-opacity="1"/></g></svg>
    `;
    btn.className = "native-video-replay-btn";
    

    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      btn.style.display = "none";
      this.videoEl.currentTime = 0; 
      this.play();
    });

  
    this.videoEl.addEventListener("ended", () => {
      btn.style.display = "flex";
    });

    this.appendChild(btn);
    this.replayBtn = btn;
  }

  _initObserver() {
    if (this.observer) return;

    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.play(); 
          } else {
            this.pause();
          }
        });
      },
      { threshold: 0.6 }
    );

    this.observer.observe(this);
  }
}

customElements.define("native-video", NativeVideo);





class NativeVideoCarousel extends HTMLElement {
  constructor() {
    super();
    this.hasRendered = false;
    this.videoEl = null;
  }

  connectedCallback() {
    if (this.hasRendered) return;
    this._render();
  }

  _render() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    const desktopTpl = this.querySelector(
      'template[data-device="desktop"]'
    );
    const mobileTpl = this.querySelector(
      'template[data-device="mobile"]'
    );

    let template = null;
    if (isMobile && mobileTpl) {
      template = mobileTpl;
    } else if (desktopTpl) {
      template = desktopTpl;
    } else {
      template = mobileTpl;
    }

    if (!template) {
      console.warn('NativeVideoCarousel: no template found', this);
      return;
    }

    const node = template.content.firstElementChild?.cloneNode(true);
    if (!node) return;

    this.innerHTML = '';
    this.appendChild(node);

    this.videoEl =
      node.tagName === 'VIDEO' ? node : node.querySelector('video');

    this.hasRendered = true;

    this.dispatchEvent(
      new CustomEvent('native-video-carousel:ready', { bubbles: true })
    );
  }
}

if (!customElements.get('native-video-carousel')) {
  customElements.define('native-video-carousel', NativeVideoCarousel);
}





// class XSequenceScroll extends HTMLElement {
//   constructor() {
//     super();
//     this.current = { frame: 0 };
//     this.frameCount = window.matchMedia('(max-width: 768px)').matches ? Number(this.getAttribute('frames')) || 60 : Number(this.getAttribute('frames')) || 60;
//     this.root = this;
//   }

//   connectedCallback() {
//     this.cacheDom();
//     this.initVH();
//     this.initCanvas();
//     this.loadImages();
//   }
//   initVH() {
//     this.updateVH();

//     const handler = () => {
//       this.updateVH();
//     };

//     if (window.visualViewport) {
//       window.visualViewport.addEventListener('resize', handler);
//     } else {
//       window.addEventListener('resize', handler);
//     }
//   }

//   updateVH() {
//     const vh =
//       (window.visualViewport && window.visualViewport.height
//         ? window.visualViewport.height
//         : window.innerHeight) * 0.01;

//     document.documentElement.style.setProperty('--vh', `${vh}px`);
//   }


//   cacheDom() {
//     this.canvas = this.root.querySelector("#sequenceCanvas");
//     this.ctx = this.canvas.getContext("2d");
//     this.aiBg = this.querySelector(".ai-bg-scroll");
//     this.box1 =  this.querySelector(".ai-line-box1");
//     this.isMobile = window.matchMedia('(max-width: 768px)').matches;
//     this.anchors = {
//       desktop: { x:  0.68, y: 0.63 }, 
//       mobile:  { x: 0.54, y: 0.12 } 
//     };
//   }

//   initCanvas() {
//     gsap.set(this.aiBg, { autoAlpha: 1 });
//     this.setCanvasSize(false);
//   }

//   setCanvasSize(shouldRender = true) {
//      if (!this.canvas) return;
//     this.canvas.width = window.innerWidth;
//     this.canvas.height = window.innerHeight;
//      if (shouldRender && this.images.length) {
//       this.render(this.current.frame / (this.frameCount - 1));
//     }
//   }



//   loadImages() {
//     this.images = [];
//     let loaded = 0;

//     for (let i = 1; i <= this.frameCount; i++) {
//       const img = new Image();
//       img.src = this.getFrame(i);
//       img.onload = () => {
//         loaded++;
//         if (loaded === this.frameCount) {
//           this.render();
//           this.startScrollAnimation();
//         }
//       };
//       this.images.push(img);
//     }
//   }

//   getFrame(i) {
//     const frameNumber = String(i).padStart(6, '0');
//     const lastFrameIndex = this.frameCount;
//     if (this.isMobile) {
//          return `https://cdn.shopify.com/s/files/1/0552/4891/2483/files/video4-0721_${frameNumber}.webp`;
//     } else {
//       return `https://cdn.shopify.com/s/files/1/0552/4891/2483/files/video4_${frameNumber}.webp`;
//     }
//   }

//   render(progress = 0) {
//     if (!this.images || !this.images.length) return;
//     const index = Math.min(this.images.length - 1, this.current.frame);
//     const img = this.images[index];
//     if (!img) return;

//     const ctx = this.ctx;
//     const canvas = this.canvas;
//     ctx.clearRect(0, 0, canvas.width, canvas.height);

//     const canvasRatio = canvas.width / canvas.height;
//     const imgRatio = img.width / img.height;

//     let drawWidth, drawHeight, offsetX, offsetY;

//     if (canvasRatio > imgRatio) {
//       drawWidth = canvas.width;
//       drawHeight = canvas.width / imgRatio;
//       offsetX = 0;
//       offsetY = (canvas.height - drawHeight) / 2;
//     } else {
//       drawHeight = canvas.height;
//       drawWidth = canvas.height * imgRatio;
//       offsetX = (canvas.width - drawWidth) / 2;
//       offsetY = 0;
//     }

//     if (index >= 21 && !this.isMobile) {
//    drawWidth = this.isMobile ? canvas.width * 1 :  canvas.width * 0.75;
//     drawHeight = drawWidth / imgRatio;
//     offsetX = (canvas.width - drawWidth) / 2;
//     offsetY = this.isMobile ? canvas.height * 1 : canvas.height * 0.25;
// }

//     ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);

// this.updateBoxPosition(offsetX, offsetY, drawWidth, drawHeight);

//   this.toggleClassByRange(this.box1, this.isMobile ? 0.8 : 0.8, this.isMobile ? 2 : 2, progress);

//   if (index >= 21 ||  this.isMobile ) {
//     this.querySelector('.ai-content')?.classList.add('active');
// } else {
// this.querySelector('.ai-content')?.classList.remove('active');
// }
//   }


// updateBoxPosition(offsetX, offsetY, drawWidth, drawHeight) {
//   if (!this.box1) return;


//   const { x, y } =  this.isMobile ? this.anchors.mobile : this.anchors.desktop;

//   const posX = offsetX + drawWidth * x;
//   const posY = offsetY + drawHeight * y;


//   this.box1.style.transform = `
//     translate(-50%, -50%)
//     translate(${posX}px, ${posY}px)
//   `;
// }


//     toggleClassByRange(el, min, max, progress) {
//     if (!el) return;
//     el.classList.remove("active", "leave");
//     if (progress >= min && progress < max) el.classList.add("active");
//     else el.classList.add("leave");
//   }


//   startScrollAnimation() {



//       const tl = gsap.timeline({
//     scrollTrigger: {
//       trigger: this.canvas,
//       start: "top 67%",
//       end: "+=350%",
//       scrub: true
//     }
//   });
//  // ① ai-bg-scroll 透明度 0 → 1
//   tl.to(this.aiBg, {
//     autoAlpha: 0,
//     duration: 0.2,  
//     ease: "none",
//   });

//   // ② 开始滚动序列帧
//   tl.to(this.current, {
//     frame: this.frameCount - 1,
//     snap: "frame",
//     ease: "none",
//     onUpdate: () => {
//       this.render(this.current.frame / (this.frameCount - 1));
//     }
//   });


//   }

// }

// window.customElements.define("x-sequence-scroll", XSequenceScroll);





class XSequenceScroll extends HTMLElement {
  constructor() {
    super();
    this.current = { frame: 0 };
    this.frameCount = window.matchMedia('(max-width: 768px)').matches ? Number(this.getAttribute('frames')) || 60 : Number(this.getAttribute('frames')) || 60;
    this.root = this;
  }

  connectedCallback() {
    this.cacheDom();
    this.initCanvas();
    this.loadImages();
  }

  cacheDom() {
    this.canvas = this.root.querySelector("#sequenceCanvas");
    this.ctx = this.canvas.getContext("2d");
    this.aiBg = this.querySelector(".ai-bg-scroll");
    this.box1 =  this.querySelector(".ai-line-box1");
    this.isMobile = window.matchMedia('(max-width: 768px)').matches;
    this.anchors = {
      desktop: { x:  0.68, y: 0.63 }, 
      mobile:  { x: 0.54, y: 0.12 } 
    };
  }

  initCanvas() {
    gsap.set(this.aiBg, { autoAlpha: 1 });
    this.setCanvasSize();
    window.addEventListener("resize", () => this.setCanvasSize());
  }

  setCanvasSize() {
    this.canvas.width = window.innerWidth;
    this.canvas.height = window.innerHeight;
    this.render();
  }



  loadImages() {
    this.images = [];
    let loaded = 0;

    for (let i = 1; i <= this.frameCount; i++) {
      const img = new Image();
      img.src = this.getFrame(i);
      img.onload = () => {
        loaded++;
        if (loaded === this.frameCount) {
          this.render();
          this.startScrollAnimation();
        }
      };
      this.images.push(img);
    }
  }

  getFrame(i) {
    const frameNumber = String(i).padStart(6, '0');
    const lastFrameIndex = this.frameCount;
    if (this.isMobile) {
         return `https://cdn.shopify.com/s/files/1/0552/4891/2483/files/video4-0722_${frameNumber}.webp`;
    } else {
      return `https://cdn.shopify.com/s/files/1/0552/4891/2483/files/video4_${frameNumber}.webp`;
    }
  }

  render(progress = 0) {
    if (!this.images || !this.images.length) return;
    const index = Math.min(this.images.length - 1, this.current.frame);
    const img = this.images[index];
    if (!img) return;

    const ctx = this.ctx;
    const canvas = this.canvas;
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    const canvasRatio = canvas.width / canvas.height;
    const imgRatio = img.width / img.height;

    let drawWidth, drawHeight, offsetX, offsetY;

    if (canvasRatio > imgRatio) {
      drawWidth = canvas.width;
      drawHeight = canvas.width / imgRatio;
      offsetX = 0;
      offsetY = (canvas.height - drawHeight) / 2;
    } else {
      drawHeight = canvas.height;
      drawWidth = canvas.height * imgRatio;
      offsetX = (canvas.width - drawWidth) / 2;
      offsetY = 0;
    }

    if (index >= 21 && !this.isMobile) {
   drawWidth = this.isMobile ? canvas.width * 1 :  canvas.width * 0.75;
    drawHeight = drawWidth / imgRatio;
    offsetX = (canvas.width - drawWidth) / 2;
    offsetY = this.isMobile ? canvas.height * 1 : canvas.height * 0.25;
}

    ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);

this.updateBoxPosition(offsetX, offsetY, drawWidth, drawHeight);

  this.toggleClassByRange(this.box1, this.isMobile ? 0.8 : 0.8, this.isMobile ? 2 : 2, progress);

  if (index >= 21 ||  this.isMobile ) {
    this.querySelector('.ai-content')?.classList.add('active');
} else {
this.querySelector('.ai-content')?.classList.remove('active');
}
  }


updateBoxPosition(offsetX, offsetY, drawWidth, drawHeight) {
  if (!this.box1) return;


  const { x, y } =  this.isMobile ? this.anchors.mobile : this.anchors.desktop;

  const posX = offsetX + drawWidth * x;
  const posY = offsetY + drawHeight * y;


  this.box1.style.transform = `
    translate(-50%, -50%)
    translate(${posX}px, ${posY}px)
  `;
}


    toggleClassByRange(el, min, max, progress) {
    if (!el) return;
    el.classList.remove("active", "leave");
    if (progress >= min && progress < max) el.classList.add("active");
    else el.classList.add("leave");
  }


  startScrollAnimation() {



      const tl = gsap.timeline({
    scrollTrigger: {
      trigger: this.canvas,
      start: "top 67%",
      end: "+=350%",
      scrub: true
    }
  });
 // ① ai-bg-scroll 透明度 0 → 1
  tl.to(this.aiBg, {
    autoAlpha: 0,
    duration: 0.2,  
    ease: "none",
  });

  // ② 开始滚动序列帧
  tl.to(this.current, {
    frame: this.frameCount - 1,
    snap: "frame",
    ease: "none",
    onUpdate: () => {
      this.render(this.current.frame / (this.frameCount - 1));
    }
  });


  }

}

window.customElements.define("x-sequence-scroll", XSequenceScroll);


    class ScrollTextZoom extends HTMLElement {
      constructor() {
        super();
      
      }
      connectedCallback() {
        this.trigger = this.querySelector('.text-zoom-section');
        this.svgText = this.querySelector('.text-zoom-svg_animated');
        this.video =  this.querySelector('.text-zoom-video');
        this.videoBg =  this.querySelector('.text-zoom-svg_bg');
        this.isMobile = window.matchMedia('(max-width: 768px)').matches;

          this.svgText1 = this.querySelector('.knockout-text');
          this.svgText2 = this.querySelector('.knockout-text-mobile-only');
          this.init();
      }
      init() {
           this.video.pause();
           this.video.currentTime = 0;
              this.tl = gsap.timeline({
      scrollTrigger: {
        trigger: this.trigger,
        start: 'top top',
        end: '+=120%',
        scrub: 1.3,
        onEnter: () =>  this.video.play(),
        onLeaveBack: () => {
           this.video.pause();
           this.video.currentTime = 0;
        }
      }
    });
    


    this.tl.to(this.isMobile ? this.svgText2 : this.svgText1, {
     scale: 500,
      svgOrigin: '50 50',
     ease: 'power3.in',
      duration: 1
    }, 0)

    

     this.tl.to(this.videoBg, {
      opacity: 0,
      ease: 'power3.in',
      duration: 0.5
    }, 0)

      }

    }

    window.customElements.define('scroll-text-zoom', ScrollTextZoom);




    class ScrollingSegmentNew extends HTMLElement {
  constructor() {
    super();
    this.scrollTrigger = null;
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      this.initScrollTrigger();
    });
  }

  disconnectedCallback() {
    if (this.scrollTrigger) {
      this.scrollTrigger.kill();
      this.scrollTrigger = null;
    }
  }

  initScrollTrigger() {
    const section = this.querySelector('.scroll-segment-section');
    const bgsection = this.querySelector('.custom-mask__bg');
    if (!section) return;

      if(bgsection){
    gsap.set(bgsection, { yPercent: 80 });
  }

    const boxes = gsap.utils.toArray(
      section.querySelectorAll('.scroll-segment-box')
    );
    if (!boxes.length) return;

    // 1. 初始化样式：第一个可见并激活，其余完全透明
    boxes.forEach((box, i) => {
      const content = box.querySelector('.scroll-segment-content');
      if (i === 0) {
        gsap.set(box, { opacity: 1, zIndex: 1 });
        content?.classList.add('active');
      } else {
        gsap.set(box, { opacity: 0, zIndex: 0 });
        content?.classList.remove('active');
      }
    });

    // 2. 创建时间轴
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top top',
        end: `+=${boxes.length * 30}%`, 
        scrub: 1
      }
    });

boxes.forEach((box, i) => {
      if (i === 0) return; 

      const prevBox = boxes[i - 1];
      const content = box.querySelector('.scroll-segment-content');
      const prevContent = prevBox.querySelector('.scroll-segment-content');

      const isPrevFirst = (i - 1) === 0;
  


      // 停留时间
     tl.to({}, { duration: 1 });

      // 3.1 上一个盒子淡出 (Opacity 1 -> 0)
      tl.to(prevBox, {
        opacity: 0,
        duration: 0.5,
        ease: 'power1.out',
        onReverseComplete: () => {
          if (!isPrevFirst) {
             prevContent?.classList.add('active');
          }
        }
      });

      // 3.2 当前盒子淡入 (Opacity 0 -> 1)
      tl.to(box, {
        opacity: 1,
        duration: 0.5,
        onStart: () => {
          content?.classList.add('active');
        },
        
        onReverseComplete: () => {
          content?.classList.remove('active');
        }
      });
    });


    // 4. 处理背景动画 (使其贯穿整个时间轴)
    if (bgsection) {
      tl.to(
        bgsection,
        {
          yPercent: 0,
          ease: 'none',
          duration: tl.duration() 
        },
        0
      );
    }

    this.scrollTrigger = tl.scrollTrigger;
  }
}

customElements.define('scroll-segment-new', ScrollingSegmentNew);





class ScrollPresentation extends HTMLElement {
    constructor() {
        super();
        this.ctx = null;
    }

    connectedCallback() {
        requestAnimationFrame(() => {
            this.initAnimation();
        });
    }

    disconnectedCallback() {
        if (this.ctx) {
            this.ctx.revert(); 
        }
    }

    initAnimation() {
        this.ctx = gsap.context((self) => {
            
            const boxes = gsap.utils.toArray('.noise-cancelling-box');

            gsap.set(boxes.slice(1), { yPercent: 100 });

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: '.scroll-segment-section',    
                    start: "top top",
                    end: "+=" + (boxes.length * 60) + "%",
                    scrub: 1,
                    onEnter: () => {

                    },
                    onLeaveBack: () => {
                      
                    }
                }
            });

            
            boxes.forEach((box, i) => {
                if (i === boxes.length - 1) return;

                const nextBox = boxes[i + 1];

                const currentInnerNodes = box.querySelectorAll('.noise-cancelling-cnt, .noise-cancelling-pic');

                const  currentCnt =  box.querySelectorAll('.noise-cancelling__animate');

                
                if(currentInnerNodes.length) {
                     tl.to(currentCnt, {
                        opacity: 0,
                        yPercent: -50,
                        scale: 0.95,
                        duration: 0.5,
                        ease: "none"
                    }, i);
                }

                tl.to(nextBox, {
                    yPercent: 0,
                    duration: 0.5,
                    ease: "none"
                }, i);
            });

        }, this);
    }
}

customElements.define('scroll-presentation', ScrollPresentation);








class WaveModal extends HTMLElement {
    constructor() {
        super();
        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
    }

    connectedCallback() {

        this.triggerBtn = this.querySelector('.hear-every-btn-new');
        const targetSelector = this.getAttribute('target');
        
        if (targetSelector) {
            this.modal = document.querySelector(targetSelector);
        } else {
            return;
        }


        if (this.modal) {
            this.closeBtns = this.modal.querySelectorAll('.close_pop');
            this.mask = this.modal.querySelector('.mask_w');
        }


       
        if (this.triggerBtn) {
            this.triggerBtn.addEventListener('click', (e) => {
                e.stopPropagation();
                this.open();
            });
        }

        
        if (this.closeBtns) {
            this.closeBtns.forEach(btn => {
                btn.addEventListener('click', (e) => {
                    e.stopPropagation();
                    this.close();
                });
            });
        }

       
        if (this.mask) {
            this.mask.addEventListener('click', (e) => {
                e.preventDefault();
                this.close();
            });
        }

        document.addEventListener('keydown', this.handleKeydown);
    }

    disconnectedCallback() {
        document.removeEventListener('keydown', this.handleKeydown);
    }

    open() {
        if (!this.modal) return;
        
        this.modal.style.display = 'block';
        requestAnimationFrame(() => {
            this.modal.classList.add('show');
        });

        document.documentElement.classList.add('wave-pop-open');
        document.body.classList.add('wave-pop-open');
    }

    close() {
        if (!this.modal) return;

        this.modal.classList.remove('show');
        setTimeout(() => {
            this.modal.style.display = 'none';
        }, 500);

        document.documentElement.classList.remove('wave-pop-open');
        document.body.classList.remove('wave-pop-open');
    }

    handleKeydown(e) {
        const isVisible = this.modal && this.modal.style.display !== 'none';
        if (e.keyCode === 27 && isVisible) {
            this.close();
        }
    }
}

customElements.define('wave-modal', WaveModal);